import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_VIEW_DETAILS } from './constants';

/**
 * Tracks a page view event into bigQuery platform.
 */
const trackBigQuery = () => {
    const { pageCtxId } = getContext();
    const { title, cookie } = document;

    bigQuery.send({
        ...PAGE_VIEW_DETAILS.BIG_QUERY,
        page: {
            title,
            cookie,
            ctx_id: pageCtxId,
            language: navigator.language
        }
    });
};

/**
 * Tracks the general page view event.
 */
const trackPageView = () => {
    trackBigQuery();
};

window.addEventListener('load', trackPageView, { once: true });
